import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "content-article-feed",
  name: "图文头条信息流",
  icon: "头",
  group: "信息流页面",
  description: "读取已发布图文，以大图、右图、三图或纯文字头条卡片展示。",
  defaultProps: {
    "title": "图文头条",
    "layoutMode": "HEADLINE",
    "pageSize": 20,
    "coverLayout": "LARGE_IMAGE",
    "showPublisher": true,
    "showPublishedAt": true,
    "showSummary": true,
    "showMetrics": true
}
}
